import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const enquiryFormSlice = createSlice({
  name: "enquiryForm",
  initialState,
  reducers: {
    submitEnquiryForm: (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    submitEnquiryFormSuccess: (state) => {
      state.loading = false;
      state.success = true;
    },
    submitEnquiryFormFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetEnquiryFormState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  submitEnquiryForm,
  submitEnquiryFormSuccess,
  submitEnquiryFormFailure,
  resetEnquiryFormState,
} = enquiryFormSlice.actions;

export default enquiryFormSlice.reducer;
